import {trimMessages} from "../../../../../../contextManagement/messageFormatter/Utils.ts";
import {formatMessages} from "../../../../../../contextManagement/messageFormatter/formatMessages.ts";
import {DEFAULT_CONTEXT_GATHER_MODEL, DEFAULT_CONTEXT_GATHER_PROVIDER} from "../../../../../../../../Globals.ts";
import {getIdToken} from "../../../../../../../misc/miscUtils.ts";
import {isIde} from "../../../../../../../misc/envNameUtils.ts";

export const executeWebsocketToolCall = async (
    websocketRef: any,
    finishedToolCall: any,
    messagesSequenceRef: any,
    messagesRef: any,
    environmentObjRef: any,
    settingsObjRef: any,
    userObjRef: any,
    dynamicStateObjRef: any
) => {
    const args = { ...finishedToolCall.args, agent: finishedToolCall.name };

    if (finishedToolCall.name === "gatherContext" || finishedToolCall.name === "deepResearch") {
        let { environment, date, projectEmbeddingsLastUpdated } = environmentObjRef.current;
        let { enableSearchInternet } = settingsObjRef.current;
        const { subscriptionPlan } = userObjRef.current;
        const { importantMessageIds } = dynamicStateObjRef.current;

        let systemMessage = `Today's date is: ${date}.
Your task is to gather the context necessary to properly answer this request.`;
        if (isIde(environment)) systemMessage += "\nYou should find the files relevant to fulfilling the user's request, but avoid over-gathering context. Only retrieve what is necessary to complete the task.";
        systemMessage += "\n\nIf you do not need any additional context, simply call done and return back.";
        systemMessage += "\nWhen you are done gathering context, call the done tool to finish up your response.";

        const {trimmedMessages} = trimMessages(messagesRef.current, messagesSequenceRef.current, 5, importantMessageIds, systemMessage);

        args.authToken = await getIdToken(userObjRef.current.user);
        args.projectName = environmentObjRef.current.projectName;
        args.messages = await formatMessages(trimmedMessages, environment, systemMessage, DEFAULT_CONTEXT_GATHER_PROVIDER, DEFAULT_CONTEXT_GATHER_MODEL, "chat", true);
        args.model = DEFAULT_CONTEXT_GATHER_MODEL;
        args.provider = DEFAULT_CONTEXT_GATHER_PROVIDER;
        args.environment = environment;
        args.subscriptionPlan = subscriptionPlan;
        args.enableSearchInternet = enableSearchInternet;
        args.enableCodebaseSearch = projectEmbeddingsLastUpdated !== null;

        // Preserve task for deepResearch calls
        if (finishedToolCall.name === "deepResearch") {
            args.task = finishedToolCall.args.task;
        }
    }

    websocketRef.current.send(JSON.stringify({functionName: 'toolAgent', args}));
};
